import * as Sentry from "@sentry/react";
import config, { IConfig } from "../../config";

interface IAbstractSentryFacade {
  setUserContext(user: { email: string }): void;
  captureException(exception: Error): void;
}

class DummySentryFacade implements IAbstractSentryFacade {
  setUserContext(): void {
    // noop
  }

  captureException(): void {
    // noop
  }
}

class ConcreteSentryFacade implements IAbstractSentryFacade {
  constructor(config: IConfig["sentry"]) {
    const appVersion = process.env["APP_VERSION"] as string;
    this.initSentry(config.dsn, appVersion, config.environment);
  }

  private initSentry(dsn: string, release: string, environment: string): void {
    Sentry.init({
      dsn,
      release,
      environment,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          maskAllInputs: false,
          networkDetailAllowUrls: [".traceair.net"],
          mutationLimit: 100000000000,
          mutationBreadcrumbLimit: 1500,
        }),
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  setUserContext(user: { email: string }): void {
    Sentry.setUser(user);
  }

  captureException(exception: Error) {
    Sentry.captureException(exception);
  }
}

export const sentrySingleton = config.sentry.enabled
  ? new ConcreteSentryFacade(config.sentry)
  : new DummySentryFacade();
